import { getCurrencyById } from "@/services/currencies/currenciesApi";
import { type CurrencyId, type Currency } from "@/services/currencies/currenciesTypes";
import type { PriceNumeric } from "@/services/prices";
import { isNumericPrice, type Price } from "@/services/prices";

export const formatAmount = (amount: number, currency: Currency): string => {
  const numStr = amount.toLocaleString("en");
  const [integerPart, decimalPart] = numStr.split(".");
  const formattedIntegerPart = integerPart.replaceAll(",", currency.thousandsSeparator);

  let formattedNumber = formattedIntegerPart;
  if (decimalPart !== undefined) {
    formattedNumber += currency.decimalSeparator + decimalPart;
  }

  return formattedNumber;
};

export const convert = async (price: Price, toCurrencyId: CurrencyId): Promise<Price> => {
  if (!isNumericPrice(price)) {
    return price;
  }

  const currencyFrom = await getCurrencyById(price.currencyId);
  const currencyTo = await getCurrencyById(toCurrencyId);

  const decimalPrecision = currencyTo.decimalPrecisionWhenCurrencySwitch;
  const ratio = currencyFrom.ratioThousands[currencyTo.id] / 1000;
  const priceConverted = price.price * ratio;
  const withoutDecimals = Number(priceConverted.toFixed(decimalPrecision));

  return {
    price: withoutDecimals,
    currencyId: currencyTo.id,
  };
};

export const assertSameCurrency = (price1: PriceNumeric, price2: PriceNumeric, msg?: string): void => {
  if (price1.currencyId !== price2.currencyId) {
    throw new Error(msg ?? "Two prices with different currency!");
  }
};
